import { canManageConnections } from "./menuAccess";
import { isAdminUser } from "./canAccessTicket";

// Status gravados pelo backend em Whatsapps.status (backend/src/libs/wbot.ts,
// CreateWhatsAppService.ts, WhatsAppSessionController.ts):
// CONNECTED | OPENING | qrcode | DISCONNECTED | deleted.
export const WHATSAPP_OFFLINE_STATUSES = ["DISCONNECTED", "qrcode"];

// OPENING e reconexao em andamento (o wbot faz backoff de 2,5s ate 5min) e
// `deleted` nao e conexao viva: nenhum dos dois gera aviso, e nenhum dos dois
// cancela um aviso em curso — so CONNECTED cancela.
export const isWhatsappOffline = whats =>
  WHATSAPP_OFFLINE_STATUSES.includes(whats?.status);

export const isWhatsappOnline = whats => whats?.status === "CONNECTED";

export const isWhatsappDeleted = whats => whats?.status === "deleted";

const activeWhatsApps = whatsApps =>
  Array.isArray(whatsApps)
    ? whatsApps.filter(w => w && !isWhatsappDeleted(w))
    : [];

// Conexoes que o proprio usuario usa: a padrao do cadastro (Users.whatsappId)
// + as atribuidas (UserWhatsapps).
const userOwnWhatsApps = (user, list) => {
  const ids = new Set();
  if (user?.whatsappId) ids.add(Number(user.whatsappId));
  if (Array.isArray(user?.whatsapps)) {
    user.whatsapps.forEach(w => {
      const id = Number(w?.id ?? w);
      if (Number.isFinite(id)) ids.add(id);
    });
  }
  if (ids.size > 0) return list.filter(w => ids.has(Number(w.id)));

  // Sem conexao propria nem atribuida, o envio cai no fallback do backend
  // (helpers/GetDefaultWhatsApp.ts): a conexao isDefault da empresa.
  const fallback = list.find(w => w.isDefault);
  return fallback ? [fallback] : [];
};

// Conexoes que acendem o badge de "Conexoes" no menu lateral.
export const getRelevantWhatsApps = (user, menus, whatsApps) => {
  const list = activeWhatsApps(whatsApps);
  if (!list.length) return [];

  // Quem gerencia conexoes responde por todas da empresa: o badge fica no
  // menu onde ele mesmo reconecta qualquer uma.
  if (canManageConnections(user, menus)) return list;

  return userOwnWhatsApps(user, list);
};

// Conexoes pelas quais ESTE usuario recebe o aviso de queda (ConnectionAlerts).
// So admin/super e avisado de todas; os demais, mesmo com o menu Conexoes, so
// das conexoes a que tem acesso — avisar da conexao de outro atendente e ruido.
export const getAlertWhatsApps = (user, whatsApps) => {
  const list = activeWhatsApps(whatsApps);
  if (!list.length) return [];
  if (isAdminUser(user)) return list;
  return userOwnWhatsApps(user, list);
};
